import { FixedRule, FixedRuleBase } from './@types/FixedRuleModel';

export class FixedRuleRepo {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getFixedRules(): Promise<FixedRule[]> {
        try {
            const response = await this.httpService.get<TKResponse<FixedRule[]>>('/fixed_rules');

            const data = response.data.map((fixedRule) => ({
                ...fixedRule,
                id: fixedRule.fixed_rule_id,
            }));
            return data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error fetching fixed rules:', error);
            throw error;
        }
    }

    async getFixedRuleById(id: number): Promise<FixedRule> {
        const response = await this.httpService.get<FixedRule>(`/fixed_rules/${id}`);
        return response;
    }

    async createFixedRule(data: FixedRuleBase): Promise<FixedRule> {
        return this.httpService.post<FixedRule, FixedRuleBase>('/fixed_rules', { data });
    }

    async deleteFixedRule(id: number): Promise<number> {
        return this.httpService.delete(`/fixed_rules/${id}`);
    }
    async updateFixedRule(id: number, data: FixedRuleBase): Promise<FixedRule> {
        return this.httpService.patch<FixedRule, FixedRuleBase>(`/fixed_rules/${id}`, { data });
    }
}
